import React from "react";
import ContentLoader from "react-content-loader";

const DashboardImageLoader = () => (
    <div className="dashboard-image-loader">
        <ContentLoader
            width={200}
            height={100}
            viewBox="0 0 150 100"
            speed={1}
            primarycolor="#f3f3f3"
            secondarycolor="#ecebeb"
        >
            <rect x="1" y="0" rx="2" ry="2" width="100%" height="400"/>
        </ContentLoader>
    </div>
);

export default DashboardImageLoader;
